<template>
  <TrainingStage />
</template>

<script>
import TrainingStage from '@/components/content/education/training/EditTrainingStage.vue'

export default {
  name: 'ContentTrainingStage',
  components: { TrainingStage }
}
</script>

<style scoped>

</style>
